import { CreateWorkerFromSelf } from "@pdfking/compatibility"

import type { Implementation } from "#public"
import type { MessageRouter } from "#public"
import type { WorkerReceiverAPI } from "#public"

import { RequestHandler } from "./RequestHandler"
import { WorkerForward } from "./WorkerForward"

export const WorkerReceiver = <T, R>(
  func: Implementation<T, R>,
  worker?: WorkerReceiverAPI<T, R>
): MessageRouter<T, R> => {
  const forward: MessageRouter<T, R> = WorkerForward(worker ?? CreateWorkerFromSelf(), (...args) =>
    runner(...args)
  )
  const runner: MessageRouter<T, R> = RequestHandler(func, forward)
  return forward
}
